

import React, { createContext, useState, useContext, useEffect } from 'react';
import { translations as defaultTranslations } from '../data/translations';
import { API_BASE } from '../config';

const LanguageContext = createContext();

// Helper for deep merging objects
const deepMerge = (target, source) => {
  for (const key in source) {
    if (source[key] instanceof Object && key in target) {
      Object.assign(source[key], deepMerge(target[key], source[key]));
    }
  }
  Object.assign(target || {}, source);
  return target;
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState('fr');
  const [translations, setTranslations] = useState(defaultTranslations);
  const [isLoading, setIsLoading] = useState(true);

  const fetchTranslations = async () => {
    try {
      const res = await fetch(`${API_BASE}/translations`);
      if (res.ok) {
        const data = await res.json();
        if (Object.keys(data).length > 0) {
            // Clone default translations to avoid mutating imports
            const merged = JSON.parse(JSON.stringify(defaultTranslations));
            
            ['fr', 'en', 'pt'].forEach(l => {
                if (data[l]) {
                    // Deep merge DB data into default translations
                    // If DB is missing keys (e.g., stats), default keys will persist
                    merged[l] = deepMerge(merged[l], data[l]);
                }
            });
            setTranslations(merged);
        }
      }
    } catch (err) {
      console.error("Erreur chargement traductions dynamiques:", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchTranslations();
  }, []);

  const refreshTranslations = async () => {
    await fetchTranslations();
  };

  const value = {
    lang,
    setLang,
    t: translations[lang] || translations['fr'],
    refreshTranslations,
    translations
  };

  if (isLoading) {
      return <div className="min-h-screen flex items-center justify-center">Chargement...</div>;
  }

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);